import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const LegendItemMarker = styled.div<{ background: string }>`
    width: 8px;
    height: 8px;
    margin-right: 8px;
    background: ${({ background }) => background};
`;

export const LegendItemValue = styled.span`
    padding-top: 4px;
    ${Fonts.Heading.H400}
    color: ${Colors.Black.V50};
`;

export const LengendItemLabel = styled.span`
    ${Fonts.Heading.H700}
    color: ${Colors.Black.V50};
`;

export const LegendVertical = styled.div`
    > div:not(:last-child) {
        margin-bottom: 20px;
    }
`;
